import loadingc from './Loading.vue'
import { createApp } from 'vue'
var loadingApp = null
const loading = {
  install: function (app) {
    loadingApp = createApp(loadingc).mount(document.createElement('div'))
    document.body.appendChild(loadingApp.$el)
    app.config.globalProperties.$loading = loading
  },
  show() {
    loadingApp.show()
  },
  hide() {
    loadingApp.hide()
  }
}
export default loading
